import type { FC } from 'react'
import LgBreakpoint from '@g4g/ui/src/utility/LgBreakpoint'
import MobileDealsHeader from './header/MobileDealsHeader'
import DesktopDealsHeader from './header/DesktopDealsHeader'
import { tickFilters } from '@g4g/utils/src/gameDataUtils'

const { category, resource } = tickFilters()

const BrowseDealsHeader: FC = () => (
  <div className="flex w-full mb-8 space-x-4 lg:mb-4 lg:justify-between lg:pb-3 xl:pl-6 min-h-[52px]">
    <LgBreakpoint
      min={<DesktopDealsHeader category={category} resource={resource} />}
      max={<MobileDealsHeader category={category} resource={resource} />}
    />
  </div>
)

export default BrowseDealsHeader
